import React, { useEffect, useState } from 'react'
import StudentForm from '../Shared/StudentForm'
import Pagination from "../General/Pagination";
import config from "../../Config";
import axios from "axios";
import moment from "moment";
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate, useParams } from 'react-router-dom';
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import StudentMenu from './StudentMenu';
import { scrollToTop } from '../Shared/ScrollOnTop';
import RightsCheck from '../General/RightsCheck';
import SessionsDropDown from '../Shared/SessionsDropDown';
import ClassesDropDown from '../Shared/ClassesDropDown';
import SectionDropDown from '../Shared/SectionDropDown';
import WingsDropDown from '../Shared/WingsDropDown';

const StudentHistory = () => {
    let params = useParams();
    const [Student_ID, setStudent_ID] = useState(params.id);
    const [Student, setStudent] = useState({});

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    //const [DefaultSession, setDefaultSession] = useState(localStorage.getItem("DefaultSession"));

    const [showFilters, setShowFilters] = useState(true);

    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [validated, setValidated] = useState(false);
    const [SessionID, setSessionID] = useState(Student?.SelectedClass?.Selected_Session?.Session_ID);
    const [ClassID, setClassID] = useState(Student?.SelectedClass?.Class_Id);
    const [WingID, setWingID] = useState(Student?.SelectedClass?.SelectedWing?.Wing_ID);
    const [SectionID, setSectionID] = useState(Student?.SelectedSection?.Section_ID);
    // console.log(ClassID, SessionID, WingID, SectionID);

    // pagination 
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const handlePageChange = (page) => {
        setPageNo(page);
    };




    useEffect(() => {


        document.title = "Student History";
        setLoading(true);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: pageNo,
            pageSize: pageSize,
            Student_ID: Student_ID,
        };
        //console.log(data);

        var api_config = {
            method: 'post',
            url: config.base_url + 'Student/GetStudentHistory',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(api_config)
            .then(function (response) {
                // console.log(response.data);

                if (response.data.status_code != 0) {
                    setStudent(response.data.ListofRecords[0]);
                    setTotalRecords(response.data.totalRecords);
                    let student = response.data.ListofRecords[0];
                    setClassID(student?.SelectedClass?.Class_Id);
                    setSessionID(student?.SelectedClass?.Selected_Session?.Session_ID);
                    setWingID(student?.SelectedClass?.SelectedWing?.Wing_ID);
                    setSectionID(student?.SelectedSection?.Section_ID);
                    setLoading(false)
                }
                else {
                    setLedger(null);
                    setTotalRecords(0)
                }

            })
            .catch(function (error) {
                //console.log(error);
            });

    }, [pageNo, pageSize]);

    return (
        <>
            <RightsCheck />
            <StudentMenu />
            <ToastContainer />
            <div className="container body-content">
                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <NavLink to="/Dashboard">Dashboard</NavLink>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <NavLink to="/students/StudentDashboard">
                                                Students
                                            </NavLink>
                                        </li>

                                        <li className="breadcrumb-item active" aria-current="page">
                                            Student History
                                        </li>
                                    </ol>
                                </nav>
                                <div className="page-title">Student History</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body card-form-wrap">
                                        {
                                            loading ?
                                                <>
                                                    <Spinner animation="border" role="status"></Spinner>
                                                </>
                                                :
                                                <>
                                                    <div className="form-wrap">
                                                        <div className="form-legend">Basic Information</div>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-9">
                                                                <div className="row align-items-center g-3 m-0">
                                                                    <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">Bay Form .</label>
                                                                    <div className="col-md-4">
                                                                        <input type="text" disable className="form-control" defaultValue={Student.Bay_Form_No} />
                                                                    </div>
                                                                    <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">Form No.</label>
                                                                    <div className="col-md-4">
                                                                        <input type="text" disabled numbers-Only className="form-control" defaultValue={Student.Form_No} id="" />
                                                                    </div>
                                                                    <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">Student Name</label>
                                                                    <div className="col-md-4">
                                                                        <input type="text" disabled className="form-control" defaultValue={Student.Student_Name} id="" />
                                                                    </div>
                                                                    <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">Date of Birth</label>
                                                                    <div className="col-md-4">
                                                                        <div className="form-control">
                                                                            {moment(Student.Date_Of_Birth).format('DD/MM/YYYY')}
                                                                        </div>
                                                                    </div>
                                                                    <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm" > Father Name </label>
                                                                    <div className="col-md-4">
                                                                        <input type="text" disabled className="form-control" defaultValue={Student.Father_Name} id="" />
                                                                    </div>
                                                                    <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">Father CNIC</label>
                                                                    <div className="col-md-4">
                                                                        <input type="text" disabled numbers-Only className="form-control" defaultValue={Student.Father_CNIC} id="" />
                                                                    </div>
                                                                    <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">Gender</label>
                                                                    <div className="col-md-9">
                                                                        <div className="mt-1">

                                                                            <div className="form-check form-check-inline">
                                                                                <label className="form-check-label">
                                                                                    <input type="radio" name="rdoResult" defaultChecked={Student.Gender} />
                                                                                    Male
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-inline me-0">
                                                                                <label className="form-check-label">
                                                                                    <input type="radio" name="rdoResult" defaultChecked={!Student.Gender} />
                                                                                    Female
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="col-md-3 text-center">
                                                                <img className="mb-3 m-auto" src={config.StudentImagePath + Student.Registration_No + ".jpg"} style={{ width: "150px", height: "150px", border: "1px solid", borderRadius: "50%", display: "block" }} />
                                                            </div>
                                                        </div>
                                                        <div className="row align-items-center mt-0">

                                                            <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">Vaccination Status</label>
                                                            <div className="col-md-4">
                                                                <input type="text" disabled numbers-Only className="form-control" defaultValue={Student.Vaccination_Status} id="" />
                                                            </div>
                                                            <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">Vaccination Date</label>
                                                            <div className="col-md-4">
                                                                <input type="text" className="form-control" defaultValue={moment(Student.Vaccination_Date).format("DD/MM/YYYY")} id="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-wrap">
                                                        <div className="form-legend">Contact Information</div>
                                                        <div className="row">
                                                            <label htmlFor="" className="col-md-3 col-form-label col-form-label-sm">Temporary Address</label>
                                                            <div className="col-md-9">
                                                                <input type="text" disabled className="form-control" defaultValue={Student.Temporary_Address} id="" />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <label htmlFor="" className="col-md-3 col-form-label col-form-label-sm">Permanent Address</label>
                                                            <div className="col-md-9">
                                                                <input type="text" disabled className="form-control" defaultValue={Student.Permanent_Address} id="" />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <label htmlFor="" className="col-md-3 col-form-label col-form-label-sm">Contact Number</label>
                                                            <div className="col-md-3">
                                                                <input type="text" disabled numbers-Only className="form-control" defaultValue={Student.Contact_Phone} id="" />
                                                            </div>
                                                            <label htmlFor="" className="col-md-3 col-form-label col-form-label-sm">Mobile Number</label>
                                                            <div className="col-md-3">
                                                                <input type="text" disabled numbers-Only className="form-control" defaultValue={Student.Contact_Mobile} id="" />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <label htmlFor="" className="col-md-3 col-form-label col-form-label-sm">Email Address</label>
                                                            <div className="col-md-9">
                                                                <input type="text" disabled className="form-control" defaultValue={Student.Contact_Email} id="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-wrap">
                                                        <div className="form-legend">Session / Wing / Class / Section</div>
                                                        <div className="row gy-3">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label>Choose Session</label>
                                                                    <select className="form-select" required
                                                                        selected={Student?.Selected_Session?.Session_Name}
                                                                    >
                                                                        <option value="">Please Select</option>
                                                                        <SessionsDropDown selectedSession={SessionID} />
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label>Choose Wing</label>
                                                                    <select
                                                                        selected={Student?.SelectedClass?.SelectedWing?.Wing_Name}

                                                                        className="form-select" required>
                                                                        <option value="">Please Select</option>
                                                                        <WingsDropDown selectedWingId={WingID} />
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label>Select Class:</label>
                                                                    <select className="form-select" required selected={Student?.SelectedClass?.Class_Name}>
                                                                        <option value="">Please Select</option>
                                                                        <ClassesDropDown
                                                                            selectedClassId={ClassID}
                                                                            SessionID={SessionID}
                                                                            WingID={WingID} />
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label>Select Section</label>
                                                                    <select className="form-select" required selected={Student?.SelectedSection?.Section_Name}>
                                                                        <option value="">Please Select</option>
                                                                        <SectionDropDown selectedSectionId={SectionID}
                                                                            ClassID={ClassID} />
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-wrap">
                                                        <div className="form-legend">Class &amp; Transport</div>
                                                        <div className="row no-gutters mb-0">
                                                            <div className="col-md-6">
                                                                <div className="row">
                                                                    <label htmlFor="" className="col-md-6 col-form-label col-form-label-sm">Wing</label>
                                                                    <div className="col-md-6">
                                                                        <input type="text" disabled numbers-Only className="form-control" defaultValue={Student?.SelectedClass?.SelectedWing?.Wing_Name} id="" />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <label htmlFor="" className="col-md-6 col-form-label col-form-label-sm">Session</label>
                                                                    <div className="col-md-6">
                                                                        <input type="text" disabled numbers-Only className="form-control" defaultValue={Student?.SelectedClass?.Selected_Session?.Session_Name} id="" />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <label htmlFor="" className="col-md-6 text-md-end col-form-label">Class</label>
                                                                    <div className="col-md-6">
                                                                        <input type="text" disabled numbers-Only className="form-control" defaultValue={Student?.SelectedClass?.Class_Name} id="" />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <label htmlFor="" className="col-md-6 col-form-label col-form-label-sm">Section</label>
                                                                    <div className="col-md-6">
                                                                        <input type="text" disabled numbers-Only className="form-control" defaultValue={Student?.SelectedSection?.Section_Name} id="" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="row">
                                                                    <label htmlFor="" className="col-md-6 col-form-label col-form-label-sm">Transport Facility</label>
                                                                    <div className="col-md-6">
                                                                        <input type="text" disabled numbers-Only className="form-control" defaultValue={Student?.SelectedRoot?.Root_Name} id="" />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <label htmlFor="" className="col-md-6 col-form-label col-form-label-sm">Concessions</label>
                                                                    <div className="col-md-6">
                                                                        <input type="text" disabled numbers-Only className="form-control" defaultValue={Student?.SelectedConcessionRule?.Concession_Rule_Name} id="" />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <label htmlFor="" className="col-md-6 col-form-label col-form-label-sm">Group</label>
                                                                    <div className="col-md-6">
                                                                        <input type="text" disabled numbers-Only className="form-control" defaultValue={Student?.SelectedGroup?.Group_Name} id="" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-wrap">
                                                        <div className="form-legend">Other Details</div>
                                                        <div className="row align-items-center gy-3">
                                                            <label htmlFor="" className="col-md-3 col-form-label col-form-label-sm">Previous School Information</label>
                                                            <div className="col-md-9">
                                                                <input type="text" disabled className="form-control" defaultValue={Student.Previous_School_Info} />
                                                            </div>
                                                            <label htmlFor="" className="col-md-3 col-form-label col-form-label-sm">NOC Board Information</label>
                                                            <div className="col-md-9">
                                                                <input type="text" disabled className="form-control" defaultValue={Student.NOC_Board} />
                                                            </div>
                                                            <label htmlFor="" className="col-md-3 col-form-label col-form-label-sm">Remarks</label>
                                                            <div className="col-md-9">
                                                                <input type="text" disabled className="form-control" defaultValue={Student.Remarks} />
                                                            </div>
                                                            <label htmlFor="" className="col-md-3 col-form-label col-form-label-sm">Record Changed By</label>
                                                            <div className="col-md-9">
                                                                <input type="text" disabled className="form-control" defaultValue={`${Student?.Selected_User?.Full_Name} (${moment(Student.Updated_Date).format('DD/MM/YYYY ,h:mm:ss a')})`} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row mt-2">
                                            <div className="col-md-9">
                                                {
                                                    <div className="pagination-wrap">
                                                        <div className="row align-items-center">
                                                            <Pagination
                                                                pageNo={pageNo}
                                                                pageSize={pageSize}
                                                                totalRecords={totalRecords}
                                                                onPageChange={handlePageChange}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="col-md-2 offset-md-1">
                                                <Link to="" className="button button-primary w-100">
                                                    Print
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StudentHistory